'use strict';

exports.__esModule = true;

var _slider = require('./slider');

var _slider2 = _interopRequireDefault(_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _slider2.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_react-slick@0.22.3@react-slick/lib/index.js
// module id = 322
// module chunks = 0 1